import userService from "@/services/UserService";

const roles = {
  state: {
    roles: [],
    role: {}
  },
  getters: {
    roles(state) {
      return state.roles;
    },
    role(state) {
      return state.role;
    }
  },
  mutations: {
    SET_ROLES_LIST(state, payload) {
      state.roles = payload;
    },
    SET_ROLE(state, payload) {
      state.role = payload;
    }
  },
  actions: {
    async setRole({ commit }, payload) {
      commit("SET_ROLE", payload);
    }
  }
};

export default roles;



// WEBPACK FOOTER //
// ./src/vuex/setting/roles.js